import { PublicHeader } from "@/components/layout/PublicHeader";

export const AuthLayout = ({ children, headline = "Your circle starts here.", testId }) => (
  <div className="min-h-screen" data-testid={testId}>
    <PublicHeader minimal />
    <div className="grid lg:min-h-[calc(100vh-74px)] lg:grid-cols-[1.15fr_1fr]">
      <aside className="relative h-[340px] overflow-hidden sm:h-[440px] lg:h-auto">
        <img src="/brand/cosmos.webp" alt="Genesis Members Club" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" aria-hidden />
        <div className="absolute inset-x-0 bottom-0 hidden p-12 lg:block">
          <h2 className="font-display text-7xl leading-[0.92]">{headline}</h2>
          <p className="mt-6 max-w-md text-lg text-foreground/90">Apply to join a community that creates exceptional experiences together.</p>
          <span className="my-6 block h-px w-14 bg-foreground/40" />
          <p className="text-sm tracking-[0.2em] text-foreground/80">Membership is subject to approval.</p>
        </div>
      </aside>
      <section className="flex items-start justify-center px-5 py-10 sm:px-10 lg:items-center lg:py-16">
        <div className="w-full max-w-[520px]">{children}</div>
      </section>
    </div>
  </div>
);
